// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm2(){
  var hoogte = $('.acf-field').find("[data-name='form2_hoogte']").find(':input').val();
  var breedte = $('.acf-field').find("[data-name='form2_breedte']").find(':input').val();
  var aantal_regels = $('.acf-field').find("[data-name='form2_regels']").find(':input').val();
  var kwaliteit = $('.acf-field').find("[data-name='form2_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var stuwdruk = $('.acf-field').find("[data-name='form2_stuwdruk']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form2_zone']").find('label.selected > input[type="radio"]').val();

  var overspanning = $('.acf-field').find("[data-name='form2_overspanning']").find(':input').val();
  var belastinglinksonder = $('.acf-field').find("[data-name='form2_belastinglinksonder']").find(':input').val();
  var belastingrechtsboven = $('.acf-field').find("[data-name='form2_belastingrechtsboven']").find(':input').val();
  var doorbuiging = $('.acf-field').find("[data-name='form2_doorbuiging']").find('label.selected > input[type="radio"]').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form2Calculate',
      hoogte: hoogte,
      breedte: breedte,
      aantal_regels: aantal_regels,
      kwaliteit: kwaliteit,
      stuwdruk: stuwdruk,
      zone: zone,
      overspanning: overspanning,
      belastinglinksonder: belastinglinksonder,
      belastingrechtsboven: belastingrechtsboven,
      doorbuiging: doorbuiging
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form2Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });
}

$(document).ready(function(){

  $('#form2Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form2Calc .acf-form-submit').append('<input type="submit" id="calculate_form2" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form2').click(function(e){
    e.preventDefault();
    calculateForm2();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form2.js